/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import RoomStatusView from '../../view/pages/room/RoomStatusView'
import RoomStatusStore from '../../store/room/RoomStatusStore'
import RoomAction from '../../action/room'
import { withRouter } from 'react-router'

class RoomStatusContainer extends Component {
  static getStores() {
    return [RoomStatusStore]
  }

  static calculateState(prevState, props) {
    return {
      rooms: RoomStatusStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    RoomAction.fetchStatus()
  }

  render() {
    return RoomStatusView(this.state)
  }
}

export default withRouter(Container.create(RoomStatusContainer, { withProps: true }))
